export default __webpack_public_path__ + "static/media/dog.e02c9beb.png";